require('./bootstrap');

export const initDynamicScripts = function () {

    $('.dynamicForm').validate({
        errorElement: 'div',
        validClass: "div",
    });

    $('#dynamicNewModal').on('show.bs.modal', function (event) {

        var button = $(event.relatedTarget);
        var qs = button.data('queryString') + "&modal=1";

        $('#dynamicNewModalLabel').html('<i class="fa fa-cog fa-spin" style="font-size: 20px"></i> Loading...');

        var $modal = $(this);

        $modal.find('.btn-primary').on('click', function () {
            $(this).find('.btn-primary').off('click').find('.fa').remove();
            $(this).append(' <i class="fa fa-cog fa-spin"></i>');
        });

        if ($('.departure_date')) {
            $('.departure_date').change(function () {
                let dep_days = $('#default-departure-days').data('default-departure-days');
                let $dep_date = $('.departure_date');
                let $ret_date = $('.return_date');
                console.log(dep_days);
                console.log($dep_date);
                console.log($ret_date);
            })
        }

        $.ajax({
            url: '/dynamic/new?' + qs,
            type: 'GET',
        }).done(function (response) {
            if (response.view) {
                $('.modal-body').html(response.view);
            } else {
                $('.modal-body').html('Processing error. Please contact technical support.');
            }
        }).fail(function (error, errorText, errorThrown) {
            console.log(error);
            console.log(errorText);
            console.log(errorThrown);
        })

    });

    $('#payment-amount').change(function () {
        var elem = $(this);
        val = numeral(elem.val()).format('0,0.00');
        elem.val(val);
    })

    $('#dynamicNewModal').on('hide.bs.modal', function (event) {
        $('.modal-body').html('');
        $(this).find('.btn-primary').off('click').find('.fa').remove();
    });

    $('#dynamicModalSubmit').on('click', function () {

        let form = $('form.dynamicForm');

        if (form.valid()) {
            
            let url = form[0].action;
            let data = new FormData(form[0]);

            $.ajax({
                url: url,
                method: 'POST',
                data: data,
                processData: false,
                contentType: false
            }).done(function (response) {
                console.log(response);
                $('.modal-body').html(response.view);
            }).fail(function (error, errorText, errorMeta) {
                console.log(error);
                console.log(errorText);
                console.log(errorMeta);
            });
        }
    });
    
    $('input[type="text"].trans-amount').change(function () {
        // Use Numeral.js instead of new Intl.NumberFormat
        var elem = $(this);
        let val = numeral(elem.val()).format('0,0.00');
        elem.val(val);
    });

    $.validator.addMethod("onlyone", function (value, element, params) {
        var $otherEl = $('[name="' + params[0] + '"]');
        $(element).on('focus blur keyup keydown change', function () {
            $otherEl.trigger('focusout');
        });
        var value2 = $otherEl.val();
        if (value == '0.00') value = false;
        if (value2 == '0.00') value2 = false;
        return !((!value && !value2) || (value && value2));
    }, $.validator.format("This field or \"{1}\" required (not both)"));


    $(document).ready(function(){
        let element = document.getElementsByClassName('form-control departure_date');

        if($('input[name^="models[departure][departure_date]"]')){
            $('input[name^="models[departure][departure_date]"]').attr('id', 'departureDate');
            let departueDate = $('input[name^="models[departure][departure_date]"]');
            $('input[name^="models[departure][departure_date]"]').change(function(){
                console.log("Changed");
            });
        }

    });
    
    let fillReturnDate = function () {
        let element = document.getElementsByClassName('form-control departure_date');
        let date = element[0].value;

        //Not 
        let departure_date = new Date(date);

        let return_date = departure_date.setDate(departure_date.getDate() + 10);
        return_date = new Date(return_date);

        //Calculations are good, getting wrong date from 'departure_date' Date object.
        console.log("Return Date: " + return_date);

    }

    $.validator.addMethod("onlyone", function(value, element, params) {
        var $otherEl = $('[name="'+params[0]+'"]');
        $(element).on('focus blur keyup keydown change', function() {
            $otherEl.trigger('focusout');
        });
        var value2 = $otherEl.val();
        if (value == '0.00') value = false;
        if (value2 == '0.00') value2 = false;
        return !((!value && !value2) || (value && value2));
    }, $.validator.format("This field or \"{1}\" required (not both)"));
}